<script setup>
import SvgIcon from '@jamescoyle/vue-icon'
import {mdiDomain, mdiShieldCrown, mdiShieldCrownOutline} from "@mdi/js"
import BeeIcon from "@/components/BeeIcon.vue"
import {DomainCertifiedIcon} from "@/icons"

import {useAuth} from "@/stores/auth.js";

const authStore = useAuth()

</script>

<template>
    <div class="UserType">
        <div v-if="authStore.authUser && authStore.authUser.isTrainee">

        </div>
        <div v-if="authStore.authUser && authStore.authUser.isProfessional"
             class="flex align-items-center gap-2"
             v-tooltip.left="authStore.authUser.isProfessionalCertified ? 'Organisme Certifié' : 'Organisme'">
            <BeeIcon v-if="authStore.authUser.isProfessionalCertified" :icon="DomainCertifiedIcon" :size="32" class="block" />
            <svg-icon v-else type="mdi" :path="mdiDomain" :size="32" class="block" />
            {{ authStore.authUser.$data.organization?.display_name }}
        </div>
        <div v-if="authStore.authUser && authStore.authUser.isSuperAdmin" v-tooltip.left="'Super Admin'" class="flex align-items-center gap-2">
            <svg-icon type="mdi" :path="mdiShieldCrown" :size="32" class="block" /> Super Admin
        </div>
        <div v-if="authStore.authUser && authStore.authUser.isAdmin" v-tooltip.left="'Admin'" class="flex align-items-center gap-2">
            <svg-icon type="mdi" :path="mdiShieldCrownOutline" :size="32" class="block" /> Admin
        </div>
    </div>

</template>

<style scoped lang="scss">

</style>
